// Note: React import removed as it's not needed with modern JSX transform

interface AvatarPlaceholderProps {
  name: string;
  className?: string;
}

export default function AvatarPlaceholder({ name, className = "" }: AvatarPlaceholderProps) {
  // Generate a consistent color based on the name
  const getColor = (name: string) => {
    const colors = [
      "bg-blue-100 text-blue-800",
      "bg-green-100 text-green-800",
      "bg-purple-100 text-purple-800",
      "bg-yellow-100 text-yellow-800",
      "bg-red-100 text-red-800",
      "bg-indigo-100 text-indigo-800",
      "bg-pink-100 text-pink-800",
      "bg-teal-100 text-teal-800"
    ];
    
    // Simple hash function to get a consistent index
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  };
  
  // Get initials from name
  const getInitials = (name: string) => {
    if (!name) return "?";
    
    return name
      .split(" ")
      .map(part => part.charAt(0))
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };
  
  const colorClass = getColor(name);
  const initials = getInitials(name);
  
  return (
    <div className={`rounded-full ${colorClass} flex items-center justify-center ${className}`}>
      <span className="font-medium text-sm">{initials}</span>
    </div>
  );
}
